import React from 'react';
import TitleWrapperComponent from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/title';

const Title = (props) => {
  const { title, sectionKey, editorRefs } = props;

  const { fullName } = editorRefs;

  return (
    <TitleWrapperComponent
      sectionKey={sectionKey}
      title={title}
      editor={fullName}
    />
  );
};

export default Title;
